<div class="dialog text-center">
  <p class="mb-4" [innerHTML]="data.title"></p>

  <form [formGroup]="downloadReport">
    <mat-radio-group formControlName="downloadType" class="mx-auto">
      <mat-radio-button value="0" disableRipple checked>{{data.radioBtn1}}</mat-radio-button>
      <mat-radio-button value="1" disableRipple>{{data.radioBtn2}}</mat-radio-button>
      <mat-radio-button *ngIf="enableCsvOption" value="2" disableRipple>CSV</mat-radio-button>
    </mat-radio-group>
  </form>

  <mat-dialog-actions class="justify-content-center mt-3">
    <button class="btn btn-lg btn-greengo" mat-button mat-dialog-close [mat-dialog-close]="true" (click)="download()">
      OK
    </button>
    <button class="btn btn-lg btn-lead-50" mat-button mat-dialog-close [mat-dialog-close]="false">Cancel</button>
  </mat-dialog-actions>
</div>